
    // Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "FullWidthSlider") {
    $this.FullWidthSliderActive();
  }else if($this.data('section') == "FullWidthSlider_2") {
   $this.FullWidthSlider_2Active();
  }else if($this.data('section') == "FullWidthSlider_3") {
   $this.FullWidthSlider_3Active();
  }else if($this.data('section') == "FullWidthSlider_4") {
   $this.FullWidthSlider_4Active();
  }else if($this.data('section') == "CollectionBanner") {
   $this.CollectionBannerActive();
  }else if($this.data('section') == "TabWithProduct") {
   $this.TabWithProductActive();
  }else if($this.data('section') == "BrandLogo") {
   $this.BrandLogoActive();
  }else if($this.data('section') == "Testimonial") {
   $this.TestimonialActive();
  }else if($this.data('section') == "Instagram") {
        $this.InstagramSection();
  }else if($this.data('section') == "HeaderSections") {
    $this.HeaderSectionsActivation();
  }else if($this.data('section') == "RelatedProduct") {
   $this.RelatedProductActive();
  }else if($this.data('section') == "CustomCollection") {
   $this.CustomCollectionActive();
  }else if($this.data('section') == "ListCollection") {
   $this.ListCollectionActive();
  }else if($this.data('section') == "BannerWithCollection") {
    $this.find('.product_column2').BannerWithCollection();
  }else if($this.data('section') == "CollectionThumbnail") {
    $this.find('.product_column1').CollectionThumbnail();
  }else if($this.data('section') == "SectionWithSidebar") {
    $this.SectionWithSidebar();
  }else if($this.data('section') == "SectionWithSidebar2") {
    $this.SectionWithSidebar2();
  }else{}   
}

    
    //  slider active js
$.fn.FullWidthSliderActive = function() {
  var $carousel = $('[data-owl-carousel]');
  var $OwlFullWidthSlider = $('.slider-active');

  if ($carousel.length) {
    $carousel.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlFullWidthSlider.owlCarousel();

  /*---background image---*/
  function dataBackgroundImage() {
    $('[data-bgimg]').each(function () {
      var bgImgUrl = $(this).data('bgimg');
      $(this).css({
        'background-image': 'url(' + bgImgUrl + ')', // + meaning concat
      });
    });
  }
  jQuery(document).ready(function(){
    dataBackgroundImage();
  });
};
    
    
    //  slider active js
$.fn.FullWidthSlider_2Active = function() {
  var $carousel2 = $('[data-owl-carousel]');
  var $OwlFullWidthSlider_2 = $('.slider-active-2');

  if ($carousel2.length) {
    $carousel2.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlFullWidthSlider_2.owlCarousel();

  /*---background image---*/
  function dataBackgroundImage() {
    $('[data-bgimg]').each(function () {
      var bgImgUrl = $(this).data('bgimg');
      $(this).css({
        'background-image': 'url(' + bgImgUrl + ')', // + meaning concat
      });
    });
  }
  jQuery(document).ready(function(){
    dataBackgroundImage();
  });
};
    
       
    //  slider active js
$.fn.FullWidthSlider_3Active = function() {
  var $carousel3 = $('[data-owl-carousel]');
  var $OwlFullWidthSlider_3 = $('.slider-active-3');

  if ($carousel3.length) {
    $carousel3.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlFullWidthSlider_3.owlCarousel();

  /*---background image---*/
  function dataBackgroundImage() {
    $('[data-bgimg]').each(function () {
      var bgImgUrl = $(this).data('bgimg');
      $(this).css({
        'background-image': 'url(' + bgImgUrl + ')', // + meaning concat
      });
    });
  }
  jQuery(document).ready(function(){
    dataBackgroundImage();
  });
};
    
    
      //  slider active js
    
    $.fn.FullWidthSlider_4Active = function() {
    
          
    $('#fullpage').fullpage({
        sectionSelector : '.flone-fp-section',
        slideSelector : '.flone-fp-slide',
        navigation : true,
        responsiveWidth: 575
    });
      
    
      };
    
    
    
       //  Collection Banner active js
$.fn.CollectionBannerActive = function() {
  var $carousel4 = $('[data-owl-carousel]');

 var $OwlCollectionBanner = $('.collection-active');

  if ($carousel4.length) {
    $carousel4.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlCollectionBanner.owlCarousel();


};
    
        
     //  Tab With Product active js
    
$.fn.TabWithProductActive = function() {
  var $carouse5 = $('[data-owl-carousel]');

 var $OwlTabWithProduct = $('.product-slider-active');

  if ($carouse5.length) {
    $carouse5.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlTabWithProduct.owlCarousel();
  


}; 
    
                 
    //  Brand Logo active js
$.fn.BrandLogoActive = function() {
  var $carouse6 = $('[data-owl-carousel]');

 var $OwlBrandLogo = $('.brand-logo-active');

  if ($carouse6.length) {
    $carouse6.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlBrandLogo.owlCarousel();


};
    
                     
    //  Testimonial active js
$.fn.TestimonialActive = function() {
  var $carouse7 = $('[data-owl-carousel]');

 var $OwlTestimonial = $('.testimonial_active');

  if ($carouse7.length) {
    $carouse7.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlTestimonial.owlCarousel();


};
    
    
    // Instgram active js
    $.fn.InstagramSection = function(){
      var activation = this.find('[data-username]'),
          activeId = activation.attr('id'),
          clientUsername = activation.attr('data-username'),
          instagramHastag = activation.attr('data-hashtag'),
          ItemsLimit = activation.attr('data-limit'),
          imageSize = activation.attr('data-size'),
          instaslider = ".instagram-carousel";

      $.instagramFeed({
        'tag': instagramHastag,
        'username': clientUsername,
        'container': "#"+activeId,
        'display_profile': false,
        'display_biography': false,
        'display_gallery': true,
        'styling': false,
        'items': ItemsLimit,
        'margin': 1,
        'image_size': imageSize
      });

 
    };
    


                     
    //  Related Product active js
$.fn.RelatedProductActive = function() {
  var $carouse8 = $('[data-owl-carousel]');

 var $OwlRelatedProduct = $('.related-product-active');

  if ($carouse8.length) {
    $carouse8.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlRelatedProduct.owlCarousel();


};


    
    //  Custom Collection active js
$.fn.CustomCollectionActive = function() {
  var $carouse9 = $('[data-owl-carousel]');

 var $OwlCustomCollection = $('.related-product-active');

  if ($carouse9.length) {
    $carouse9.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlCustomCollection.owlCarousel();


};
    

    
    //  Custom Collection active js
$.fn.ListCollectionActive = function() {
  var $carouse10 = $('[data-owl-carousel]');

 var $OwlListCollection = $('.related-product-active');

  if ($carouse10.length) {
    $carouse10.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlListCollection.owlCarousel();


};
    





$.fn.HeaderSectionsActivation = function() {
   

  
     /* Cart search */
    $(".account-satting-active , .search-active").on("click", function(e) {
        e.preventDefault();
        $(this).parent().find('.account-dropdown , .search-content').slideToggle('medium');
    })
    
    /* Cart dropdown */
    var iconCart = $('.icon-cart');
    iconCart.on('click', function() {
        $('.shopping-cart-content').toggleClass('cart-visible');
    })


      
    /* Language dropdown */
    $(".language-style a").on("click", function(e) {
        e.preventDefault();
        $(this).parent().find('.lang-car-dropdown').slideToggle('medium');
    })
    
    
    /* use style dropdown */
    $(".use-style a").on("click", function(e) {
        e.preventDefault();
        $(this).parent().find('.lang-car-dropdown').slideToggle('medium');
    })
    
  
      
    /*--- Clickable menu active ----*/
    const slinky = $('#menu').slinky()
    
    /*====== sidebarCart ======*/
    function sidebarMainmenu() {
        var menuTrigger = $('.clickable-mainmenu-active'),
            endTrigger = $('button.clickable-mainmenu-close'),
            container = $('.clickable-mainmenu');
        menuTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('inside');
        });
        endTrigger.on('click', function() {
            container.removeClass('inside');
        });
    };
    sidebarMainmenu();
    
  
  
	
  $('.mega-menu-li').parent('ul').addClass('mega-menu');
  $('.sub-menu-li').parent('ul').addClass('submenu');


  
  
};


(function($) {
  "use strict";

  jQuery(document).ready(function(){
    
    

    
    $('.quickview-slide-active a').on('click', function() {
        $('.quickview-slide-active a').removeClass('active');
    })
    
 
    /*-----------------------------------
        Scroll zoom
    -------------------------------------- */
    window.sr = ScrollReveal({
        duration: 800,
        reset: false
    });
    sr.reveal('.scroll-zoom');
    
    
    /*-----------------------
        Shop filter active 
    ------------------------- */
    $('.filter-active a').on('click', function(e) {
        e.preventDefault();
        $('.product-filter-wrapper').slideToggle();
    })
    
    

    
    /*=========================
		Toggle Ativation
	===========================*/
    function itemToggler() {
        $(".toggle-item-active").slice(0, 8).show();
        $(".item-wrapper").find(".loadMore").on('click', function(e) {
            e.preventDefault();
            $(this).parents(".item-wrapper").find(".toggle-item-active:hidden").slice(0, 4).slideDown();
            if ($(".toggle-item-active:hidden").length == 0) {
                $(this).parent('.toggle-btn').fadeOut('slow');
            }
        });
    }
    itemToggler();
    
    
    function itemToggler2() {
        $(".toggle-item-active2").slice(0, 8).show();
        $(".item-wrapper2").find(".loadMore2").on('click', function(e) {
            e.preventDefault();
            $(this).parents(".item-wrapper2").find(".toggle-item-active2:hidden").slice(0, 4).slideDown();
            if ($(".toggle-item-active2:hidden").length == 0) {
                $(this).parent('.toggle-btn2').fadeOut('slow');
            }
        });
    }
    itemToggler2();
    
    function itemToggler3() {
        $(".toggle-item-active3").slice(0, 8).show();
        $(".item-wrapper3").find(".loadMore3").on('click', function(e) {
            e.preventDefault();
            $(this).parents(".item-wrapper3").find(".toggle-item-active3:hidden").slice(0, 4).slideDown();
            if ($(".toggle-item-active3:hidden").length == 0) {
                $(this).parent('.toggle-btn3').fadeOut('slow');
            }
        });
    }
    itemToggler3();
    
    
    /*--------------------------
        ScrollUp
    ---------------------------- */
    $.scrollUp({
        scrollText: '<i class="fa fa-angle-double-up"></i>',
        easingType: 'linear',
        scrollSpeed: 900,
        animation: 'fade'
    });
    
    
    /*--------------------------
        Isotope
    ---------------------------- */
    
    $('.grid').imagesLoaded(function() {
        // init Isotope
        $('.grid').isotope({
            itemSelector: '.grid-item',
            percentPosition: true,
            layoutMode: 'masonry',
            masonry: {
                // use outer width of grid-sizer for columnWidth
                columnWidth: '.grid-sizer',
            }
        });
    });
    

    
    /*=========================
		Toggle Ativation
	===========================*/
    function itemToggler4() {
        $(".toggle-item-active4").slice(0, 6).show();
        $(".item-wrapper4").find(".loadMore4").on('click', function(e) {
            e.preventDefault();
            $(this).parents(".item-wrapper4").find(".toggle-item-active4:hidden").slice(0, 3).slideDown();
            if ($(".toggle-item-active4:hidden").length == 0) {
                $(this).parent('.toggle-btn4').fadeOut('slow');
            }
        });
    }
    itemToggler4();

    function itemToggler5() {
        $(".toggle-item-active5").slice(0, 6).show();
        $(".item-wrapper5").find(".loadMore5").on('click', function(e) {
            e.preventDefault();
            $(this).parents(".item-wrapper5").find(".toggle-item-active5:hidden").slice(0, 3).slideDown();
            if ($(".toggle-item-active5:hidden").length == 0) {
                $(this).parent('.toggle-btn5').fadeOut('slow');
            }
        });
    }
    itemToggler5();

    function itemToggler6() {
        $(".toggle-item-active6").slice(0, 6).show();
        $(".item-wrapper6").find(".loadMore6").on('click', function(e) {
            e.preventDefault();
            $(this).parents(".item-wrapper6").find(".toggle-item-active6:hidden").slice(0, 3).slideDown();
            if ($(".toggle-item-active6:hidden").length == 0) {
                $(this).parent('.toggle-btn6').fadeOut('slow');
            }
        });
    }
    itemToggler6();
    
    
    /*--------------------------
        Product Zoom
	---------------------------- */
    $(".zoompro").elevateZoom({
        gallery: "gallery",
        galleryActiveClass: "active",
        zoomWindowWidth: 300,
        zoomWindowHeight: 100,
        scrollZoom: false,
        zoomType: "inner",
        cursor: "crosshair"
    });
    

    
    /*---------------------
        Video popup
    --------------------- */
    $('.video-popup').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        zoom: {
            enabled: true,
        }
    });

    
    /*--
    Magnific Popup
    ------------------------*/
    $('.img-popup').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
    });
    
    
    /*-------------------------
    Create an account toggle
    --------------------------*/
    $('.checkout-toggle2').on('click', function() {
        $('.open-toggle2').slideToggle(1000);
    });
    
    $('.checkout-toggle').on('click', function() {
        $('.open-toggle').slideToggle(1000);
    });
    
    
    /*---- CounterUp ----*/
    $('.count').counterUp({
        delay: 10,
        time: 1000
    });
  
    
    /*my jq add点击空白处，user下拉隐藏*/
    $("body").click(function(){
 
　　$(".account-dropdown").hide();
 
    });
 
   $(".account-satting-active").click(function(e){
 
　　$(".account-dropdown").show();
　　e.stopPropagation();//阻止冒泡到body
 
   });
 
   $(".account-dropdown").click(function(e){//自己要阻止
 
　　e.stopPropagation();//阻止冒泡到body
 
   });
    
    
    /*my jq add点击空白处，cart下拉隐藏*/
    $("body").click(function(){
 
　　$(".shopping-cart-content").hide();
 
    });
 
    $(".icon-cart").click(function(e){
 
　　$(".shopping-cart-content").show();
　　e.stopPropagation();//阻止冒泡到body
 
    });
 
    $(".shopping-cart-content").click(function(e){//自己要阻止
 
　　e.stopPropagation();//阻止冒泡到body
 
    });
    
    
    /*my jq add点击空白处，search下拉隐藏*/
    $("body").click(function(){
 
　　$(".search-content").hide();
 
    });
 
    $(".search-active").click(function(e){
 
　　$(".search-content").show();
　　e.stopPropagation();//阻止冒泡到body
 
    });
 
    $(".search-content").click(function(e){//自己要阻止
 
　　e.stopPropagation();//阻止冒泡到body
 
    });

   /*hide mobile menu*/
  $("body").click(function(){
 
　　$(".clickable-mainmenu.inside").hide();
 
    });
 
    $(".clickable-menu").click(function(e){
 
　　$(".clickable-mainmenu.inside").show();
　　e.stopPropagation();//阻止冒泡到body
 
    });
 
    $(".clickable-mainmenu.inside").click(function(e){//自己要阻止
 
　　e.stopPropagation();//阻止冒泡到body
 
    });
    
    /*footer mobile menu toggle start*/
    $(function(){
     var _width = $(window).width(); 
     if(_width <= 749){
            $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(2) > div > ul").hide();
            $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(2) > div > p").click(function(){
  $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(2) > div > ul").toggle("openlist");
            });        
    }
});
    
    
    $(function(){
     var _width = $(window).width(); 
     if(_width <= 749){
            $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(3) > div > ul").hide();
            $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(3) > div > p").click(function(){
 $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(3) > div > ul").toggle("openlist");
            });        
    }
});

    $(function(){
     var _width = $(window).width(); 
     if(_width <= 749){
            $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(4) > div > div").hide();
            $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(4) > div > p").click(function(){
 $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(4) > div > div").toggle("openlist");
            });        
    }
});
    

/*footer arrow rotate 20220712*/
    $(function(){
     var _width = $(window).width(); 
     if(_width <= 749){
            $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(3) > div > p").click(function(){
 $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(3) > div > p > i").toggleClass("open");
            });        
    }
});

    $(function(){
     var _width = $(window).width(); 
     if(_width <= 749){
            $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(2) > div > p").click(function(){
 $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(2) > div > p > i").toggleClass("open");
            });        
    }
});

    $(function(){
     var _width = $(window).width(); 
     if(_width <= 749){
            $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(4) > div > p").click(function(){
 $("#shopify-section-alternate-footer > footer > div:nth-child(1) > div > div:nth-child(4) > div > p > i").toggleClass("open");
            });        
    }
});

    
/*banner and menu color*/
$(document).ready(function(){
      if($("section-1549441904306 > div > div.owl-stage-outer.owl-stage> div > div:nth-child(4)").hasClass("active")){
           $(".transparent-bar i.fa").addClass("menu-color");
}  
});

/*product quantity selector 20220802*/
    $('.pro-details-quality .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.pro-details-quality').find('.cart-plus-minus-box').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.pro-details-quality').find('.cart-plus-minus-box').val(qty);
}); 
    
/*product cart quantity selector 20220808*/
    $('.product-quantity .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.product-quantity').find('.cart-plus-minus-box').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.product-quantity').find('.cart-plus-minus-box').val(qty);
}); 

/*mobile search box stop page scroll 20220804*/
 $(function(){
     var _width = $(window).width(); 
     if(_width <= 767){
        $(".search-active").click(function(){
            $("body").css('overflow', 'hidden');  
            });        
    };
        $(document).on('click', function () {
            $('body').css('overflow', 'auto');  
     });
});
    
/*mobile side-menu stop page scroll 20220804*/
 $(function(){
     var _width = $(window).width(); 
        $(".clickable-menu").click(function(){
            $("body").css('overflow', 'hidden');  
            });        
        $(document).on('click', function () {
            $('body').css('overflow', 'auto');  
     });
});


/*collection top banner slide 20220809*/
 $(document).ready(function(){
     var href = document.URL;
     if (href.indexOf('https://jigsawdepov.com/collections/puzzle-board')>0){
        alert('hello');
        $('.pro-sidebar-title').css('color','red !important');
};
});   
    
/*the close )*/    
  });
  
})(jQuery);
